import { MRT_Localization } from 'material-react-table';
import { MRT_Localization_DE } from 'material-react-table/locales/de';
import { MRT_Localization_EN } from 'material-react-table/locales/en';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { MRT_Localization_FR } from 'material-react-table/locales/fr';
import { MRT_Localization_PT } from 'material-react-table/locales/pt';
import { useIntl } from 'react-intl';

/** Map app locale to MRT localization. es-AR and es use Spanish. */
const MRT_LOCALE_MAP: Record<string, MRT_Localization> = {
  de: MRT_Localization_DE,
  en: MRT_Localization_EN,
  es: MRT_Localization_ES,
  fr: MRT_Localization_FR,
  pt: MRT_Localization_PT,
};

const MRT_DEFAULT_LOCALE = MRT_Localization_ES;

/**
 * Returns the Material React Table localization object for the current app locale.
 * Resolves exact locale first, then base language (e.g. es from es-AR), then defaults to Spanish.
 */
export function useMrtLocale(): MRT_Localization {
  const { locale } = useIntl();

  return MRT_LOCALE_MAP[locale] ?? MRT_LOCALE_MAP[locale.split('-')[0]] ?? MRT_DEFAULT_LOCALE;
}
